export const isIe11 = () =>
  '-ms-scroll-limit' in document.documentElement.style &&
  '-ms-ime-align' in document.documentElement.style &&
  !document.evaluate




// WEBPACK FOOTER //
// ./src/utils/ie.js